import { memo } from "react";
import MenuItemDivider from "./MenuItemDivider";
import SaveAs from "./SaveAs";
import { Node } from "@tiptap/pm/model";
import { CheckStatus } from "../hooks/CheckStatus";
import { StatusMessage } from "./StatusMessage";

const EXPORT_RICH_FORMAT = false

type SpecialMenuProps = {
    clean: () => void
    getState: () => Node
    getText: () => string
    status: CheckStatus
}

const SpecialMenu = ({ status, clean, getState, getText } : SpecialMenuProps) => {
    return (
    <div>
        <StatusMessage status={status} />
        <div className="menu special-menu">
                    <Exporta getState={getState} />
                    <span id="copy-text" className="icon-inline" onClick={() => {
                        navigator.clipboard.writeText(getText())
                    }}>
                        <i className="fa fa-clipboard" aria-hidden="true"></i> Copia el text pla
                    </span>
                    <MenuItemDivider />
                    <span id="clear_text" onClick={clean} className="icon-inline">
                        <i className="fa fa-eraser" aria-hidden="true"></i> Esborra el text
                    </span>
        </div>
    </div>)
}

const Exporta = ({ getState } : { getState: () => Node}) => {
    return EXPORT_RICH_FORMAT ? <>
                    <SaveAs format="odt" getState={getState} />
                <SaveAs format="docx" getState={getState} />
                <MenuItemDivider />
    </> : <></>
}

const MemoizedSpecialMenu = memo(SpecialMenu)

export default MemoizedSpecialMenu
